import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import CaptionBox from '../../../common/CaptionBox';
import PatternBox from './PatternBox';
import PatternChartBox from './PatternChartBox';
import useImage from 'hooks/common/useImage';

export default function PatternSummaryBox(props) {
  const {
    caption,
    pattern,
    description,
    data,
    ...rest
  } = props || {};

  const {
    dawn_pattern_info = '',
    morning_pattern_info = '',
    lunch_pattern_info = '',
    evening_pattern_info = '',
    search_dv,
    search_key,
    image,
  } = data || {};

  const src = useImage(image);
  return (
    <div {...ex('PatternSummaryBox', rest)}>
      <div>
        <div>
          <div>
            <CaptionBox {...{ caption }} />
          </div>
          <div>
            <PatternBox {...{ pattern, description }} />
          </div>
        </div>
        <div>
          {src && (
            <img
              {...{
                src,
                alt: 'Chart',
              }}
            />
          )}
        </div>
      </div>
      <div>
        <table>
          <thead>
            <tr>
              <th>
                <div>
                  {T('새벽(0-6H)')}
                </div>
              </th>
              <th>
                <div>
                  {T('오전(6-12H)')}
                </div>
              </th>
              <th>
                <div>
                  {T('오후(12-18H)')}
                </div>
              </th>
              <th>
                <div>
                  {T('저녁(18-24H)')}
                </div>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <div>
                  {dawn_pattern_info}
                </div>
              </td>
              <td>
                <div>
                  {morning_pattern_info}
                </div>
              </td>
              <td>
                <div>
                  {lunch_pattern_info}
                </div>
              </td>
              <td>
                <div>
                  {evening_pattern_info}
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}
